import API from '../services/api'
import { IOrder, ORDER_STATUS } from '../containers/OrderForm/orderFormSlice'

export const getOrders = async (
    locationId: string,
    orderId: string = '',
    createdAt: number | string = '',
    currentDayOnly: boolean = true
) => {
    return await API.get(
        `/order?locationId=${locationId}&createdAt=${createdAt}&orderId=${orderId}&pageSize=12&currentDayOnly=${currentDayOnly}`
    )
}

export const setOrderStatus = async (id: string, orderStatus: ORDER_STATUS) => {
    return await API.put(`/order/${id}`, {
        orderStatus,
    })
}

export const setOrderDiscount = async (id: string, discount: number) => {
    return await API.post(`/order/${id}/discount`, {
        discount,
    })
}

export const createOrder = async (data: any) => {
    return await API.post('/order', data)
}
export const createOrderAsAdmin = async (data: any) => {
    return await API.post('/order/approved', data)
}

export const getDailyStatisticsForLocation = async (
    locationId: string,
    startDate: number | string = '',
    endDate: number | string = '',
    hidden: boolean = false
) => {
    return await API.get(
        `/order/location/${locationId}/${startDate}/${endDate}?hidden=${hidden}`
    )
}

export const deleteOrder = async (id: string) => {
    return await API.delete(`/order/${id}`)
}
